<template>
  <div class="v-view chart-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>

    <v-chart
      v-if="lineData.length > 0"
      ref="chart"
      class="cv-chart"
      :options="lineOption"
      @mouseover="onMouseOver"
      @globalout="onGlobalOut"
      autoresize
    ></v-chart>
    <div v-else class="cv-nodata">暂无数据!</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { numToThousands } from '@/utils';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';

export default {
  name: 'ServiceStatis',
  computed: {
    ...mapGetters(['cid']),
    chart() {
      return this.$refs.chart && this.$refs.chart['chart'];
    },
  },
  props: {
    type: {
      type: String,
      default: 'line',
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '服务数据统计',
    },
  },
  watch: {
    lineData(newData, oldData) {
      const newItem = newData.length && newData[0];
      const oldItem = oldData.length && oldData[0];
      if (!oldItem || newItem.JJCount !== oldItem.JJCount || newItem.ZFCount !== oldItem.ZFCount) {
        this.lineOption.dataset.source = newData.reverse().map((item) => ({
          month: item.Month + '月',
          house: item.JJCount,
          govern: item.ZFCount,
        }));
        this.$nextTick(() => {
          if (this.chart && !this.lineInterval) this.startAnimation();
        });
      }
    },
  },
  data() {
    return {
      dataIndex: -1,
      dataInterval: null,
      lineInterval: null,
      lineOption: {
        grid: {
          top: '15%',
          left: '3%',
          right: '5%',
          bottom: '5%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#ffebe0',
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            fontSize: 12,
            color: '#fff',
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          splitNumber: 5,
          axisLine: {
            lineStyle: {
              color: '#ffebe0',
            },
          },
          axisLabel: {
            fontSize: 12,
            color: '#fff',
          },
          splitLine: {
            show: true,
            lineStyle: {
              opacity: 0.3,
            },
          },
        },
        legend: {
          show: true,
          top: 'top',
          left: 'center',
          itemGap: 50,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#fff',
            fontSize: 14,
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        dataset: {
          source: [],
        },
        series: [
          {
            type: 'line',
            // name: '居家上门服务',
            symbolSize: 5,
            label: {
              show: true,
              position: 'top',
              distance: 8,
              color: '#ff2538',
              formatter: (params) => {
                const { value } = params;
                return numToThousands(value.house);
              },
            },
            itemStyle: {
              color: '#ff2538',
            },
            lineStyle: {
              color: '#ff2538',
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(255,37,56,0.5)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(255,37,56,0)',
                  },
                ],
                global: false,
              },
              shadowBlur: 10,
              shadowColor: 'rgba(255,37,56,0.8)',
            },
            encode: {
              x: 'month',
              y: 'house',
              tooltip: 'house',
            },
          },
          
          /*{
            type: 'line',
            name: '政府购买服务',
            label: {
              show: true,
              position: 'top',
              distance: 0,
              color: '#00afe3',
              formatter: (params) => {
                const { value } = params;
                return numToThousands(value.govern);
              },
            },
            itemStyle: {
              color: '#00afe3',
            },
            lineStyle: {
              color: '#00afe3',
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(0,175,227,0.5)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(0,175,227,0)',
                  },
                ],
                global: false,
              },
              shadowBlur: 10,
              shadowColor: 'rgba(0,175,227,0.8)',
            },
            encode: {
              x: 'month',
              y: 'govern',
              tooltip: 'govern',
            },
          },*/
        ],
      },
      lineData: [],
    };
  },
  created() {
    this.getServiceStatisData(this.cid);
  },
  mounted() {
    this.dataInterval = setInterval(() => {
      this.getServiceStatisData(this.cid);
    }, this.$interval);
  },
  beforeDestroy() {
    if (this.dataInterval) {
      clearInterval(this.dataInterval);
      this.dataInterval = null;
    }
    if (this.lineInterval) {
      clearInterval(this.lineInterval);
      this.lineInterval = null;
    }
  },
  methods: {
    onMouseOver() {
      if (this.lineInterval) {
        clearInterval(this.lineInterval);
        this.lineInterval = null;
      }
    },
    onGlobalOut() {
      !this.lineInterval && this.startAnimation();
    },
    startAnimation() {
      const dataLen = this.lineData.length;
      if (dataLen > 1) {
        this.lineInterval = setInterval(() => {
          if (this.dataIndex < dataLen - 1) {
            this.dataIndex++;
          } else {
            this.dataIndex = 0;
          }
          this.chart.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: this.dataIndex,
          });
        }, 3000);
      }
    },
    getServiceStatisData(cid) {
      this.$api
        .getServiceStatis(cid)
        .then((data) => {
          // console.log(data)
          if (!data || !data.length) return;
          this.lineData = data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
